<template>
  <vs-popup class="customer-create-popup"
            id="popup"
            :title="`CREATE SAGE CUSTOMER (${customer_data.company_name})`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-alert v-if="!credit_details" color="danger" class="h-auto">
        Please configure the customer credit account first.
      </vs-alert>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off" v-if="credit_details">

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="account_status_type" name="account_status_type" rules="required" v-slot="{ errors }">
                <small class="label">Account Status Type</small>
                <v-select :clearable="false" label="description" v-model="createForm.account_status_type" :reduce="option => option.value" :options="acc_status_types" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="currency_id" name="currency_id" rules="required" v-slot="{ errors }">
                <small class="label">Currency</small>
                <v-select disabled :clearable="false" label="name" v-model="createForm.currency_id" :reduce="option => option.id" :options="currency_list" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="country_code_id" name="country_code_id" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :clearable="false" label="name" v-model="createForm.country_code_id" :reduce="option => option.id" :options="country_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Create</vs-button>
            <vs-button @click="open = falase" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SageRepository = RepositoryFactory.get('sage')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import SageHelper from '@/mixins/SageHelper'
  import SageFactory from '@/mixins/SageFactory'
  const CustomerRepository = RepositoryFactory.get('customer')


  function initialState() {
    return {
      open: false,
      customer_id: '',
      customer_data: {},
      createForm: {
        currency_id: null,
        account_status_type: 'AccountStatusActive'
      },
      credit_details: null,
      countryCodes: [],
      currencies: [],
      acc_status_types: [],
      exchange_rate_types: [],
      country_codes: [],
      currency_list: [],
    }
  }

export default {
  name: 'CreateSageCustomerPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (customer_id, data, sector_list) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.customer_id = customer_id
        this.customer_data = data

        const main_address = data.addresses.find((x) => x.type === 'main')
        await this.fetchStatusTypes()

        this.createForm.name = data.company_name
        this.createForm.reference = data.account_number.match(/\d+/)[0]
        this.createForm.short_name = ''
        this.createForm.on_hold = false
        this.createForm.status_reason = ''
        this.createForm.telephone_country_code = data.country_code_main_telephone
        this.createForm.telephone_area_code = ''
        this.createForm.telephone_subscriber_number = data.main_telephone
        this.createForm.fax_country_code = data.country_code_fax
        this.createForm.fax_area_code = ''
        this.createForm.fax_subscriber_number = data.fax
        this.createForm.website = data.website
        this.createForm.credit_limit = this.credit_details ? this.credit_details.credit_limit : 0,
        this.createForm.payment_terms_days = data.payment_terms ? Number(data.payment_terms) : 0,
        this.createForm.terms_agreed = true,
        this.createForm.main_address = {
          address_1: main_address ? main_address.line1 : "",
          address_2: main_address ? main_address.line2 : "",
          address_3: main_address ? main_address.line3 : "",
          city: main_address ? main_address.town_state: "",
          country: main_address ? main_address.country : "",
          postcode: main_address ? main_address.post_code : "",
          address_country_code_id: this.createForm.country_code_id
        }
        if(data.industry_sector.length > 0) {
          const sectors_names = data.industry_sector.map((x) => {
              let find = sector_list.find((y) => y.id === x)
              return find ? find.name : ""
          })
          this.createForm.analysis_code_4 = sectors_names.toString()
        }
        this.createForm.analysis_code_3 = data.account_handler || "N/A",

        this.open = true;
      } catch (error) {

      }
    },

    async fetchStatusTypes() {
      this.$vs.loading()
      try {
        this.credit_details =  (await CustomerRepository.getCustomerAccountCredit(this.customer_id)).data.data
        this.acc_status_types =  (await SageRepository.getAccountStatusTypes()).data.data
        this.country_codes =  (await SageRepository.getCountryCodes()).data.data
        this.currency_list =  (await SageRepository.getCurrencies()).data.data
        this.sageCurrencyMapper(this.customer_data.account_currency)
        this.sageCountryMapper()
      } catch (e) {
        this.sageAuthHandler(e.response.status)
      }
      this.$vs.loading.close()
    },

    async onClickCreateStaffUser () {
      const vue = this;
      this.$vs.loading()
       try {
         const { data } = (await SageRepository.createCustomer(this.customer_id, this.createForm)).data
        //  const sage_customer_id = data.id
        //  if(this.customer_data.contacts.length > 0) {
        //   for (let index = 0; index < this.customer_data.contacts.length; index++) {
        //     const contact = this.customer_data.contacts[index];
        //     if(contact.type === 'account_payable') {
        //       await this.createCustomerSageContact(sage_customer_id, contact)
        //     }
        //   }
        //  }
         this.showSuccessMessage('Sage customer created successfully')
         await vue.$parent.loadCustomerDetails()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async sageCurrencyMapper(code) {
      const currencyMap = {
        'GBP': 'Pound Sterling',
        'USD': 'US Dollar',
        'EUR': 'Euro',
        'AUD': 'Australian Dollar',
        'DKK': 'Danish Krone'
      };
      const currencyName = currencyMap[code];
      const sageCurrencyObj = this.currency_list.find(currency => currency.name === currencyName);
      this.createForm.currency_id = sageCurrencyObj ? sageCurrencyObj.id : null
    },
    sageCountryMapper() {
      if(this.customer_data.addresses.length > 0) {
        const find = this.country_codes.find((x) => x.name === this.customer_data.addresses[0].country)
        this.createForm.country_code_id = find ? find.id : null
      }
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages, SageFactory, SageHelper],
}
</script>

<style scoped>
  .customer-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }
</style>
